import React from "react";
import { IncomeData } from "@/interface/entityInterface";
import { sheet } from "@/interface/dataInterface";
import VehicleCard from "../components/VehicleCard";
import CommonDetailsDialog from "@/components/common/details/DetailsDialog";
import { Table, TableHeader, TableRow, TableHead, TableBody, TableCell } from "@/components/ui/table";
import { format } from "date-fns";

interface IncomeDetailsSheetProps extends sheet {
  income: IncomeData | null;
}

export const IncomeDetails: React.FC<IncomeDetailsSheetProps> = ({
  income,
  open,
  setOpen,
}) => {
  if (!income) return null;

  return (
    <CommonDetailsDialog open={open} setOpen={setOpen} title='Income details' description={`Total breakdown of income # ${income.id}`}>
                <div className="w-full max-w-2xl mx-auto bg-background shadow-md overflow-hidden sm:rounded-lg">
              <div className="px-6 py-4 space-y-6">
                <div className="flex justify-between">
                  <VehicleCard vehicle={income.vehicle}/>
                  <div className="text-right">
                    <p className="text-sm text-gray-600 dark:text-gray-400">{format(income.date, "dd MMMM yyyy HH:mm")}</p>
                    <p className="text-sm text-gray-600 dark:text-gray-400">{income.odometer} km</p>
                  </div>
                </div>
                <Table>
                  <TableHeader>
                    <TableRow>
                      <TableHead>Name</TableHead>
                      <TableHead>Price</TableHead>
                    </TableRow>
                  </TableHeader>
                  <TableBody>
                    <TableRow >
                      <TableCell>{income.incomings_type.name}</TableCell>
                      <TableCell>${income.value}</TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
                <div>
                  {income.notes}
                </div>
              </div>
            </div>
            </CommonDetailsDialog>
  );
};
